import {
  UnitBrandSetupPage,
  UnitModelsSetupPage,
} from "src/container/Administration/Setups";

import SettingsLayout from "./SettingsLayout";
import { unitsSettingsTabs } from "./settingsRoutes";

type UnitsSettingsTab = "brand" | "model";

interface UnitsSettingsPageProps {
  tab: UnitsSettingsTab;
}

const unitsSettingsContent = {
  brand: <UnitBrandSetupPage />,
  model: <UnitModelsSetupPage />,
};

const UnitsSettingsPage = ({ tab }: UnitsSettingsPageProps) => (
  <SettingsLayout titleKey="units_settings" activeKey={tab} tabs={unitsSettingsTabs}>
    {unitsSettingsContent[tab]}
  </SettingsLayout>
);

export default UnitsSettingsPage;
